import React from 'react'
import { isNil } from 'lodash'
import { InvoiceDeliveryItemDto } from '../../api/dto/invoice-delivery.dto'
import { DeliveryRatio } from './InvoiceDeliveryTable.styles'

interface DeliveryRatioBadgeProps {
  stats: InvoiceDeliveryItemDto['emailStats']
}

const DeliveryRatioBadge: React.FC<DeliveryRatioBadgeProps> = ({ stats }) => {
  if (isNil(stats) || stats.total === 0 || stats.delivered === stats.total) {
    return null
  }
  const { delivered, total } = stats
  return (
    <DeliveryRatio
      title={`${delivered} of ${total} recipient${total === 1 ? '' : 's'} delivered`}
    >
      {delivered}/{total} delivered
    </DeliveryRatio>
  )
}

export { DeliveryRatioBadge }
